'use client';

import {
	AccordionItem,
	AccordionItemContent,
	AccordionItemTrigger,
	Link,
} from '@packages/chakra-v3';

import { Stack } from '@chakra-ui/react';
import { useLocale } from 'next-intl';
import type { NavigationMenuItemType } from '@/modules/sanity-studio/types';

type DrawerMenuAccordionItemProps = {
	menu:    NavigationMenuItemType;
	onClick: () => void;
};

const DrawerMenuAccordionItem = ({
	menu,
	onClick,
}: DrawerMenuAccordionItemProps) => {
	const locale = useLocale();

	const getLabel = (titleObj: NavigationMenuItemType['title']) => titleObj?.[locale] || Object.values(titleObj)[0] || '';

	return (
		<AccordionItem border={'0px'} mt={4} value={getLabel(menu.title)}>
			<AccordionItemTrigger textStyle={'s6'}>
				{getLabel(menu.title)}
			</AccordionItemTrigger>
			<AccordionItemContent>
				<Stack
					gap={4}
					pl={4}
					pt={2}
					textStyle={'p3'}
				>
					{menu.children?.map(link => (
						<Link key={link.href ?? getLabel(link.title)} href={link.href || '#'} onClick={onClick}>
							{getLabel(link.title)}
						</Link>
					))}
				</Stack>
			</AccordionItemContent>
		</AccordionItem>
	);
};

export default DrawerMenuAccordionItem;